import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import {cookies} from '@stubhub/react-cookies';
import {connect, Controller} from '@stubhub/react-store-provider';

import {ReduxSellTicketActions} from '../../../apps/sellTicket/config';
import {getContact} from '../../util/api';
import Loader from '../../util/loader';

const NAMESPACE = 'user';

const load = (userGUID = cookies.get('session_userGUID')) => {
  return async (dispatch, getState) => {
    const {primaryContact, primaryContactLoading} = getLocalState(getState());
    if (!primaryContactLoading && !primaryContact?.name) {
      dispatch({
        type: ReduxSellTicketActions.PERSONAL_DETAILS_LOADING,
        primaryContactLoading: true
      });

      const contactData = await getContact(userGUID);
      const primaryContact = contactData.contactsV2.contactV2.find((it) => it.defaultInd === 'Y');
      cookies.set('session_contactGUID', primaryContact.id);

      dispatch({
        type: ReduxSellTicketActions.PERSONAL_DETAILS,
        primaryContact,
        userContactData: contactData.contactsV2.contactV2,
        primaryContactLoading: false
      });
    }
  };
};

const getLocalState = (state = {}) => {
  return state[NAMESPACE] || initialState;
};

export const userController = new Controller({
  namespace: NAMESPACE,
  reducers: [ReduxSellTicketActions.PERSONAL_DETAILS, ReduxSellTicketActions.PERSONAL_DETAILS_LOADING],
  mapStateToProps: (state) => {
    return {
      ...getLocalState(state)
    };
  },
  actionCreators: {
    load
  }
});

const initialState = {
  primaryContact: {},
  userContactData: {},
  primaryContactLoading: false
};

export const withUser = (Comp, {wait = true} = {}) => {
  const WithUser = ({load, ...props}) => {
    const sessionGUID = cookies.get('session_userGUID');

    useEffect(() => {
      sessionGUID && load(sessionGUID);
    }, [load, sessionGUID]);

    return (
      <Loader loading={wait && !props.primaryContact}>
        <Comp {...props} />
      </Loader>
    );
  };

  WithUser.propTypes = {
    load: PropTypes.func,
    primaryContact: PropTypes.object
  };

  return connect(userController)(WithUser);
};

export default withUser;
